module.exports = "/components/components/errorBanner-fee30c.html";